import React from 'react';
import PropTypes from 'prop-types';
import {translate} from '../../../services';
import {isNotUndefined} from '../../../utils/validation';

const ChunkingInfo = (props) => {
  const {quantity, piecesAtChosenChunkSize, chunkSize, unit, remainingChunkSizeIsPositive, chunkSizeOfRemainingPieces} = props;

  return (
    <p className='b-chunk-size'>
      {isNotUndefined(quantity) && `${quantity} ${unit} `}
      {`= ${translate('fabric.content.pieceAmount', {
        context: piecesAtChosenChunkSize
      })} ${translate('fabric.content.chunkPiecesInfo', {
        chosenChunkSize: chunkSize,
        chunkUnit: unit
      })}`}
      {remainingChunkSizeIsPositive && <React.Fragment>
        {`, ${translate('fabric.content.pieceAmount', {
          context: 1
        })} ${translate('fabric.content.remainingChunkPiecesInfo', {
          remainingChunkSize: chunkSizeOfRemainingPieces,
          chunkUnit: unit
        })}`}
      </React.Fragment>}
    </p>
  );
};

ChunkingInfo.propTypes = {
  quantity: PropTypes.number,
  piecesAtChosenChunkSize: PropTypes.number,
  chunkSize: PropTypes.number,
  unit: PropTypes.string,
  remainingChunkSizeIsPositive: PropTypes.bool,
  chunkSizeOfRemainingPieces: PropTypes.number
};

export default ChunkingInfo;
